module.exports = __webpack_public_path__ + "static/profil-375_optimized-66a47063066b09005b6c1fe0e6b2598e.jpg";